import { render, staticRenderFns } from "./UpdateNaw.vue?vue&type=template&id=6d8ad230&"
import script from "./UpdateNaw.vue?vue&type=script&lang=ts&"
export * from "./UpdateNaw.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateNaw.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports